<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:45:10
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-13 17:48:23
-->
<template>
  <div class="full-image" v-show="visible" :before-close="onClose" :modal="true">
    <div class="mask"></div>
    <div class="image-box">
      <img :src="url" />
    </div>
    <div class="close" @click="onClose">x</div>
  </div>
</template>

<script>
export default {
  name: "fullImage",
  data() {
    return {
      fit: 'contain'
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  },
  props: {
    visible: {
      type: Boolean
    },
    url: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.full-image {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.9;
  }

  .image-box {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
    }
  }

  .close {
    position: fixed;
    top: 10px;
    right: 10px;
    color: white;
    font-size: 25px;
    cursor: pointer;
  }
}
</style>